import React, { useState } from "react";
import { Box, Alert, Tabs, Tab } from "@mui/material";

import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import OverviewTab from "./Tabs/OverviewTab";
import CredentialsTab from "./Tabs/CredentialsTab";
import PennerRennerTab from "./Tabs/PennerRennerTab";
import SellerboardTab from "./Tabs/SellerboardTab";
import PopulateArticlesTab from "./Tabs/PopulateArticlesTab";
import ArticlesManagementTab from "./Tabs/ArticlesManagementTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const PlentyPage = () => {
  // Generall
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    // Clear any existing messages when switching tabs
    setError(null);
    setSuccess(null);
  };

  return (
    <DashboardLayout>
      <MDBox>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Plenty Management Service
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Overview" />
            <Tab label="Credentials" />
            <Tab label="Penner Renner" />
            <Tab label="Stock" />
            <Tab label="Populate Articles" />
            <Tab label="Articles" />
          </Tabs>
        </Box>

        {/* Overview Tab */}
        <TabPanel value={tabValue} index={0}>
          <OverviewTab />
        </TabPanel>

        {/* Google Credentials Tab */}
        <TabPanel value={tabValue} index={1}>
          <CredentialsTab />
        </TabPanel>

        {/* Sheets Settings Tab */}
        <TabPanel value={tabValue} index={2}>
          <PennerRennerTab />
        </TabPanel>

        {/* Sheets Settings Tab */}
        <TabPanel value={tabValue} index={3}>
          <SellerboardTab />
        </TabPanel>

        {/* Populate Articles Tab */}
        <TabPanel value={tabValue} index={4}>
          <PopulateArticlesTab />
        </TabPanel>

        {/* Articles Management Tab */}
        <TabPanel value={tabValue} index={5}>
          <ArticlesManagementTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default PlentyPage;
